import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from './runtime.actions';
import cloneDeep from 'clone-deep';

export interface State {
  quotingId: string;
}

export const featureKey = 'flowDataRuntime';

export const initialState: State = {
  quotingId: null,
};

export function runtimeReducer(state: State | undefined, action: Action): State {
  return createReducer(
    initialState,
    on(Actions.ResetRuntime, (state, {}) => ({
      ...state,
      quotingId: null,
    })),
    on(Actions.UpdateQuotingId, (state, { data }) => ({
      ...state,
      quotingId: cloneDeep(data),
    }))
  )(state, action);
}
